import { useMutation, useQueryClient } from '@tanstack/react-query'
import { markJetAssignmentsReturnRequested } from 'api/admin/jet/markJetAssignmentsReturnRequested'
import { jetKeys } from './keys'

export const useMarkJetAssignmentsReturnRequestedMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (file: File) => markJetAssignmentsReturnRequested(file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: jetKeys.assignments() })
    },
  })
}
